import { updateField } from 'vuex-map-fields';

const mutations = { updateField };

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/submit/mutations.js